<script>
  import Footer from "../components/Footer/Footer.svelte";
  import NavBar from "../components/Navigation/NavBar.svelte";
  import ChallengeDropdown from "../components/ChallengeDropdown.svelte";
  import { afterUpdate } from 'svelte'
  import { getFlamelinkChallenges } from "../services/flamelink.js";
  import ProgramReadingMaterials from "../components/Program/ProgramReadingMaterials.svelte";

  let challenges = getFlamelinkChallenges();
  let uploadSource = "";
  let videoPoster = "";
let challangeImage = "";

  function getImagesAndVideosFromChallenge(challenge) {

    let out = [];


      let obj = {
        isVideo: false,
        isImage: false,
        isThumb: false,
        url: ''
      }

      challenge.challengeImage.forEach(x => {
        console.log("images", x.url)
        out.push({
          isImage: true,
          url: x.url
        })
      })

      let video = ''
      let thumb = ''

      challenge.challengeVideo.forEach(x => {
        video = x.url
      })

      challenge.videoThumbnail.forEach(x => {
        thumb = x.url
      })

      if(video != '') {
        out.push({
          isVideo: true,
          url: video,
          thumb: thumb,
        })
      }

      challengeImageAndVideo = out;
  }

  export let weeklyChallenges;

  $: challengeImageAndVideo = [];
  $: selectedChallenge = "";
  let description;
  $: hasLoaded = false;
  afterUpdate(() => {
    if(hasLoaded == false) {
      if(weeklyChallenges.length != 0) {
        hasLoaded = true;
        selectedChallenge = weeklyChallenges[weeklyChallenges.length - 1]
        updateDescription();
        getImagesAndVideosFromChallenge(selectedChallenge);
      }
    }
  })
  

  function updateDescription() {
    description.innerHTML = selectedChallenge.challengeDescription.replace(/\n/g, '<br/>') || '';
  }

</script>

<div
  style="width: 100%; max-width: 500px; display: flex; justify-content: space-between; flex-direction: column; "
>
  <div>
    <h1 class="header_text" style="margin-top: 20px; margin-bottom: 20px;">
      CHALLENGES
    </h1>

    <ChallengeDropdown
      {weeklyChallenges}
      selectedWeek = {selectedChallenge}
      onChangeSelectedWeek={(week) => {
        selectedChallenge = week;
        updateDescription();
        getImagesAndVideosFromChallenge(selectedChallenge);
      }}
    />


      {#each challengeImageAndVideo as item}

        {#if item.isImage}
        <img src={item.url} alt="" style="width: 100%; object-fit: cover; margin-top: 10px;" />
        {/if}

        {#if item.isVideo}
        <!-- svelte-ignore a11y-media-has-caption -->
        <video
          style="width: 100%; margin-top: 15px"
          src={item.url}
          controls="controls"
          poster={item.thumb}
        />
        {/if}
        <div style="height: 10px" />

      {/each}

      <p class="body_text" style="margin: 15px; margin-left: 0px;">
        {selectedChallenge ? selectedChallenge.weekNumber : ''}
      </p>
      <h1 class="header_text" style="margin: 0; margin-bottom: 10px">
        {selectedChallenge.challengeTitle || ''}
      </h1>
      <div bind:this={description} class="body_text"></div>
  </div>

  <ProgramReadingMaterials selectedWeek ={selectedChallenge} />
  <div style="height: 50px" />
  <Footer />
</div>
